export enum AccountsState {
    NotExist,
    Deleted,
    Disabled,
    NotLinkedToJournals,
    Ok
}